export const teamRole = {
    OWNER: 'Owner',
    MANAGER: 'Manager',
    VIEWER: 'Viewer',
};
